<template>
  <div>
    <div>
      <div class="text-right">
        <a @click="showEdit"> <v-icon small color="primary">edit</v-icon>แก้ไข </a>
      </div>
      <v-row no-gutters dense>
        <v-col cols="12">
          <div class="titleprofile">Member ID:</div>
          <div class="subprofile" style="color: black">{{ data.memberid }} [{{ data.membertype }}]</div>
        </v-col>
      </v-row>
    </div>
    <div class="titleprofile">ชื่อหน่วยงาน</div>
    <div class="subprofile">
      {{ data.institute_name ? data.institute_name : "-" }}
    </div>
    <div class="titleprofile">ชื่อผู้ประสานงาน</div>
    <div class="subprofile">
      {{ data.coordinator_name ? data.coordinator_name : "-" }}
    </div>
    <div class="titleprofile">ชื่อคณะ</div>
    <div class="subprofile">{{ data.faculty ? data.faculty : "-" }}</div>
    <div class="titleprofile">รหัสคณะ</div>
    <div class="subprofile">{{ data.faculty_id ? data.faculty_id : "-" }}</div>
    <div class="titleprofile">
      {{ data.phone_number ? "เบอร์โทรศัพท์" : "อีเมล" }}
    </div>
    <div class="subprofile">
      {{ data.phone_number ? data.phone_number : data.email ? data.email : "-" }}
    </div>
    <v-dialog v-model="isEdit" persistent width="500px">
      <v-card class="Kanit">
        <div class="pa-3">
          <h3><v-icon color="black">edit</v-icon>แก้ไขข้อมูล</h3>
          <div>
            <ValidationObserver ref="observer">
              <div>
                <div>
                  <ValidationProvider name="รูปโปรไฟล์" :key="'รูปโปรไฟล์'" :rules="{ required: false }" v-slot="{ errors }">
                    <upload-profile :errors="errors" v-model="data.profile_pic" :height="120"></upload-profile>
                  </ValidationProvider>
                </div>
                <div>
                  <div style="color: grey">ชื่อหน่วยงาน</div>
                  <ValidationProvider name="ชื่อหน่วยงาน" :key="'ชื่อหน่วยงาน'" :rules="{ required: true }" v-slot="{ errors }">
                    <v-text-field :error-messages="errors" v-model="data.institute_name" outlined dense></v-text-field>
                  </ValidationProvider>
                </div>
                <div>
                  <div style="color: grey">ชื่อผู้ประสานงาน</div>
                  <ValidationProvider name="ชื่อผู้ประสานงาน" :key="'ชื่อผู้ประสานงาน'" :rules="{ required: true }" v-slot="{ errors }">
                    <v-text-field v-model="data.coordinator_name" :error-messages="errors" outlined dense></v-text-field>
                  </ValidationProvider>
                </div>
                <template v-if="data.membertype == 'มหาวิทยาลัย'">
                  <div>
                    <div style="color: grey">ชื่อคณะ</div>
                    <ValidationProvider name="ชื่อคณะ" :key="'ชื่อคณะ'" :rules="{ required: true }" v-slot="{ errors }">
                      <v-text-field v-model="data.faculty" :error-messages="errors" outlined dense></v-text-field>
                    </ValidationProvider>
                  </div>
                  <div>
                    <div style="color: grey">รหัสคณะ</div>
                    <ValidationProvider name="รหัสคณะ" :key="'รหัสคณะ'" :rules="{ required: true }" v-slot="{ errors }">
                      <v-text-field v-model="data.faculty_id" :error-messages="errors" outlined dense></v-text-field>
                    </ValidationProvider>
                  </div>
                </template>
                <div>
                  <div style="color: grey">อัปโหลดเอกสาร</div>
                </div>
                <div style="display: flex; flex-direction: row">
                  <!-- <div class="px-2">
              <v-icon size="35">mdi-upload</v-icon>
            </div> -->
                  <div style="width: 100%">
                    <ValidationProvider name="เอกสาร" :key="'เอกสาร'" :rules="{ required: true }" v-slot="{ errors }">
                      <UploadDocument :errors="errors" v-model="data.document"></UploadDocument>
                    </ValidationProvider>
                  </div>
                </div>

                <input style="height: 0px; width: 0px; visibility: hidden" type="file" ref="fileuploadinput" />
                <div style="color: grey">อีเมล</div>
                <ValidationProvider name="อีเมล" :key="'อีเมล'" :rules="{ required: true }" v-slot="{ errors }">
                  <v-text-field v-model="data.email" :error-messages="errors" outlined dense></v-text-field>
                </ValidationProvider>
                <div style="color: grey">เบอร์โทรศัพท์</div>
                <ValidationProvider name="เบอร์โทรศัพท์" :key="'เบอร์โทรศัพท์'" :rules="{ required: true }" v-slot="{ errors }">
                  <v-text-field v-model="data.phone_number" :error-messages="errors" outlined dense></v-text-field>
                </ValidationProvider>
                <div v-if="data.email && data.phone_number">
                  <div style="color: grey">ช่องทางการส่ง OTP</div>
                  <ValidationProvider name="ช่องทางการส่ง OTP" :key="'otp'" :rules="{ required: true }" v-slot="{ errors }">
                    <v-radio-group v-model="data.otp" :error-messages="errors">
                      <v-radio label="อีเมล" value="email"></v-radio>
                      <v-radio label="เบอร์โทรศัพท์" value="phonenumber"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </div>
              </div>
            </ValidationObserver>
          </div>
          <div>
            <v-btn depressed :loading="saveloading" @click="onSave" color="primary" class="text-capitalize" block large>บันทึก</v-btn>
          </div>
          <div>
            <v-btn depressed @click="Cancel" color="primary" class="text-capitalize" block large text>ยกเลิก</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="checkOtp" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="Kanit">
        <v-toolbar dark color="primary">
          <!-- <v-btn icon dark @click="checkOtp = false">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
          <v-toolbar-title class="w-100 text-center">Verification Code</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="pa-3">
          <span style="color:#0c2f53;cursor:pointer" @click="checkOtp = false">< back</span>
          <div style="height: 60px; padding-top: 10px">
            <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
          </div>
          <v-container>
            <div class="text-center mt-6" style="font-size: 30px; font-weight: 900; line-height: 40px">กรอก {{ labelOTP }}</div>
            <div class="text-center mb-4" style="color: grey">Refs: {{ ref }}</div>
            <ValidationObserver ref="observer">
              <ValidationProvider :name="labelOTP" :key="labelOTP" :rules="{ required: true }" v-slot="{ errors }">
                <div style="position: relative" class="inputdistance">
                  <v-text-field type="tel" v-mask="'######'" height="3em" :name="labelOTP" :error-messages="errors" v-model="otpInput" :placeholder="labelOTP" outlined :hide-details="errors.length ? false : true" style="border-radius: 6px"></v-text-field>
                </div>
              </ValidationProvider>
            </ValidationObserver>
            <div class="flex-all-center mt-2">
              <div
                @click="resendOtp"
                class="text-center mb-3 mt-2"
                style="
              color: #162e50;
              background-color: #dadada;
              width: max-content;
              padding: 3px 18px;
              border: 1px solid transparent;
              border-radius: 8px;
            "
              >
                Resend {{ labelOTP }}
                <div style="color: red" v-if="errorSpam">
                  กรุณารอ 1 นาทีจึงจะส่งได้อีกครั้ง
                </div>
              </div>
            </div>
            <div class="submitbtn mt-5">
              <v-btn :loading="saveloading" depressed @click="next" class="text-capitalize" color="primary" block>Next</v-btn>
            </div>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadProfile from "@/components/UploadProfile.vue";
import UploadDocument from "@/components/UploadDocumentProfile.vue";
import config from "@/config";
import moment from "moment";
import axios from "axios";
export default {
  props: ["data"],
  components: {
    UploadProfile,
    UploadDocument,
  },
  data() {
    return {
      isEdit: false,
      saveloading: false,
      tempEdit: "",
      checkOtp: false,
      labelOTP: "Verification Code",
      errorSpam: "",
      ref: "",
      otpInput: "",
    };
  },
  methods: {
    showEdit() {
      this.isEdit = true;
      this.tempEdit = JSON.stringify(this.data);
    },
    Cancel() {
      this.data = JSON.parse(this.tempEdit);
      this.isEdit = false;
    },
    async next() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.saveloading = true;
        await this.verifyOTP();
      }
    },
    verifyOTP() {
      var vm = this;
      return new Promise((resolve) => {
        var data = {
          otp: this.otpInput,
          userid: this.userid,
          pageid: this.query.pageid,
          referral: this.ref,
        };

        axios
          .post(this.serverUrl + "depaverifyotp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              await vm.updateData();
              vm.checkOtp = false;
              vm.isEdit = false;
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonText: "ยืนยัน",
                confirmButtonColor: "#152d53",
              });
              resolve();
            }
          });
      });
    },
    updateData() {
      let body = { ...this.data, skip: true };

      axios
        .put(config.serverUrl + "webview/editDepaMemberInfo", body, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then((response) => {
          this.saveloading = false;
          if (response.data.responsecode == 200) {
            this.isEdit = false;
          }
        });
      this.isEdit = false;
    },
    async resendOtp() {
      var vm = this;
      var spamotp;
      if (localStorage.getItem("spamotp")) {
        spamotp = JSON.parse(localStorage.getItem("spamotp"));
        if (moment(spamotp).diff(moment(), "second") < 1) {
          localStorage.removeItem("spamotp");
          vm.errorSpam = "";
          await this.deparequestotp();
          this.$swal.fire({
            text: "ส่ง OTP ใหม่อีกครั้งสำเร็จ",
            icon: "success",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#152d53",
          });
        } else {
          vm.errorSpam = moment(spamotp).format("เวลา HH:mm วันที่ DD/MM/YYYY");
        }
      } else {
        await this.deparequestotp();
        this.$swal.fire({
          text: "ส่ง OTP ใหม่อีกครั้งสำเร็จ",
          icon: "success",
          confirmButtonText: "ยืนยัน",
          confirmButtonColor: "#152d53",
        });
        spamotp = moment().add(1, "minute");
        localStorage.setItem("spamotp", JSON.stringify(spamotp));
      }
    },
    deparequestotp() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.query.pageid,
          userid: this.userid,
          skip: true,
        };
        if (this.data.otp == "phonenumber") {
          Object.assign(data, {
            phone_number: this.data.phone_number,
          });
        }
        if (this.data.otp == "email") {
          Object.assign(data, { email: this.data.email });
        }
        axios
          .post(this.serverUrl + "deparequestotp", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.ref = response.data.data[0].referral;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
            resolve();
          });
      });
    },
    async onSave() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        if (this.data.email || this.data.phone_number) {
          let body = {
            pageid: "DEPA",
            memberid: this.data.memberid,
          };
          if (this.data.email) {
            body.email = this.data.email;
          }
          if (this.data.phone_number) {
            body.phone_number = this.data.phone_number;
          }
          let resData = await axios.post(config.serverUrl + "checkDubplicateEmailOrPhone", body, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          });
          if (resData && resData.data && resData.data.responsecode == 200 && !resData.data.dubplicate) {
            this.checkOtp = true;
            this.saveloading = false;
            this.deparequestotp();
          } else {
            this.$swal.fire({
              title: "อีเมลหรือเบอร์โทรศัพท์ซ้ำ",
              type: "error",
            });
            this.saveloading = false;
          }
        } else {
          axios
            .put(config.serverUrl + "webview/editDepaMemberInfo", this.data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then((response) => {
              this.saveloading = false;
              if (response.data.responsecode == 200) {
                this.isEdit = false;
              }
            });
          this.isEdit = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
